import React from 'react';
import NoSSR from 'react-no-ssr';
import Chip from 'Chip';
import PropTypes from 'prop-types';
import Ad from '@ifeng-fe/ui_pc_ad';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Footer from '@ifeng-fe/container_content/common/client/components/footer';
import styles from './index.css';

class BottomFooter extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
                content: { footer, bottomAd },
            } = this.props;

            return (
                <footer>
                    <NoSSR>
                        <Ad content={bottomAd} styleName={styles.ad} />
                    </NoSSR>
                <Chip id="20036" type="struct" title="全站通用页尾导航" groupName="底部" content={footer}>
                    <Footer />
                </Chip>
            </footer>
        );
    }
}

export default errorBoundary(BottomFooter);
